class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-search-input]');
    this.results = this.querySelector('[data-predictive-search]');
    this.popular = this.querySelector('[data-popular-searches]');
    this.searchCount = this.querySelector('[data-search-count]');
    this.loading = this.querySelector('[data-spinner]');
    this.submit = this.querySelector('button[type="submit"]');
    this.clear = this.querySelector('[data-clear-search]');
    this.cache = new Map();
    this.timer = null;
    this.controller = null;
    this.bind();
  }

  bind() {
    if (!this.input || !this.results) return;

    this.input.addEventListener('input', () => {
      window.clearTimeout(this.timer);
      this.updateClear();
      this.timer = window.setTimeout(() => this.change(), 180);
    });

    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length >= 2) this.change();
    });

    if (this.clear) {
      this.clear.addEventListener('click', (event) => {
        event.preventDefault();
        this.input.value = '';
        this.close(true);
        this.updateClear();
        this.input.focus();
      });
    }

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close(false);
    });
  }

  change() {
    const query = this.input.value.trim();
    if (query.length < 2) {
      this.close(false);
      return;
    }
    this.fetchResults(query);
  }

  async fetchResults(query) {
    const key = query.toLowerCase();
    if (this.cache.has(key)) {
      this.render(this.cache.get(key));
      return;
    }

    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    this.setLoading(true);

    const routes = window.MinimogSettings && window.MinimogSettings.routes ? window.MinimogSettings.routes : {};
    const root = routes.predictive_search_url || ((window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root + 'search/suggest' : '/search/suggest');
    const fields = 'title,product_type,vendor,variants.sku,variants.title,body,tag';
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '6');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', fields);
    params.set('section_id', 'predictive-search');

    try {
      const response = await fetch(root + '?' + params.toString(), {
        headers: { Accept: 'text/html' },
        signal: this.controller.signal
      });

      const text = await response.text();
      if (!response.ok) throw new Error(response.status + ': ' + text);

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search');
      if (!section) throw new Error('Predictive search section missing');

      const html = section.innerHTML;
      this.cache.set(key, html);
      this.render(html);
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.results.innerHTML = '<div class="ep-search-empty">Suche konnte nicht geladen werden.</div>';
        this.open();
      }
    } finally {
      this.setLoading(false);
    }
  }

  render(html) {
    this.results.innerHTML = html;
    this.open();
    if (this.popular) this.popular.classList.add('m:hidden');
    if (this.searchCount) this.searchCount.classList.remove('m:hidden');
  }

  open() {
    this.results.classList.remove('m:hidden');
    this.setAttribute('open', '');
    this.input.setAttribute('aria-expanded', 'true');
  }

  close(reset) {
    if (reset) this.results.innerHTML = '';
    this.results.classList.add('m:hidden');
    this.removeAttribute('open');
    if (this.popular) this.popular.classList.remove('m:hidden');
    if (this.searchCount) this.searchCount.classList.add('m:hidden');
    if (this.input) this.input.setAttribute('aria-expanded', 'false');
  }

  setLoading(active) {
    if (this.loading) {
      if (this.loading.classList.contains('ep-inline-search__spinner')) this.loading.classList.toggle('is-visible', active);
      else this.loading.style.visibility = active ? 'visible' : 'hidden';
    }
    if (this.submit) this.submit.style.visibility = active ? 'hidden' : 'visible';
  }

  updateClear() {
    if (!this.clear) return;
    if (this.clear.classList.contains('ep-inline-search__clear')) this.clear.classList.toggle('is-visible', Boolean(this.input.value));
    else this.clear.style.visibility = this.input.value ? 'visible' : 'hidden';
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}